@use 'sass:map';
@use 'sass:list';

@import '../../global/style/utilities/globals';
@import '../../global/style/nano-theme/colours';

:host {
  display: block;
  flex: 1 1 100%;
}

.main-search {
  display: flex;
  background: white;
  font-size: 14px;
  min-height: calc(100vh - 63px);
  justify-content: space-between;

  &__wrap {
    /* autoprefixer: ignore next */
    display: contents;
    height: 100%;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    margin: 0;
    padding: 0;
  }

  button:not(.result__tags-tag) {
    appearance: none;
    border: none;
    background: none;
    position: relative;
    inset-block-start: -2px;
  }

  .icon-button {
    color: inherit;
    align-self: normal;
    padding: 9px 7px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  &__topbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-block-end: 1em;

    &::after {
      content: '';
      width: calc(100% - 30px);
      inset-inline-start: 30px;
      position: relative;
      border-block-end: 1px solid #e5eef1;
      padding-block-start: 0.9em;
    }
  }

  &__applied-filters {
    border: solid 1px map.get($colors, lightgrey);
    text-transform: uppercase;
    border-radius: 3px;
    font-weight: bold;
    display: flex;
    align-items: center;
    line-height: 0.9;
    padding: 5px 5px 0 5px;
    letter-spacing: 2px;
    flex-wrap: wrap;
    margin-block-end: 0.5rem;

    span {
      display: flex;
      align-items: center;
    }

    :host(.small) & {
      display: none;
    }
  }

  &__applied-nofilter {
    margin-inline: 0 5px;
    margin-block: 0 3px;
    padding-inline: 7px;
    padding-block: 10px;
    font-size: 12px;
    color: rgba(69, 85, 86, 0.85);
  }

  &__applied-filter {
    padding-inline: 8px 2px;
    padding-block: 5px 3px;
    margin-inline: 0 5px;
    margin-block: 0 5px;
    color: map.get($colors, darkgrey);
    font-size: 11px;
    border-radius: 2px;
    border: solid 1px rgba(0, 132, 169, 0.5);
    background-color: rgba(0, 132, 169, 0.2);
    line-height: 1;

    .icon-button {
      padding-inline: 10px 4px;
      padding-block: 2px 1px;

      nano-icon {
        pointer-events: none;
      }
    }
  }

  .topbar {
    &__bkbtn {
      position: relative;
      inset-inline-start: -7px;
    }

    &__query {
      :host(.small) & {
        display: none;
      }
    }

    &__filtering {
      display: flex;
      align-items: center;
      margin-block: 0;
      margin-inline: 1em 0;
      flex: 1;
    }

    &__order {
      min-width: 175px;
      max-width: 200px;
      margin-inline-start: auto;

      :host(.small) & {
        max-width: 300px;
      }
    }

    nano-select {
      opacity: 1;
      transition: 0.1s ease opacity;

      &:not(.hydrated) {
        opacity: 0;
      }
    }

    &__show-filters {
      margin-inline-start: 0.5em;
      text-transform: uppercase;
      display: none;
      flex-direction: column;
      align-items: center;

      nano-icon {
        font-size: 20px;
      }

      :host(.small) & {
        display: flex;
      }
    }

    &__filter-count {
      width: 12px;
      height: 12px;
      box-shadow: inset 0 3px 4px 0 rgba(0, 0, 0, 0.2);
      border: solid 1px #005c76;
      background-color: #005c76;
      color: white;
      font-size: 7px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      margin-block-end: 3px;
    }
  }

  &__results {
    font-size: 14px;
    padding: 1em 40px;
    color: rgba(69, 85, 86, 0.85);
    width: 70%;
    height: 100%;

    @include media-breakpoint-down('sm') {
      padding: 1em 20px;
    }

    :host(.small) & {
      width: 100%;
    }
  }

  &__filters {
    outline: none;
    padding-inline: 0 40px;
    padding-block: 1.8em 1em;

    @include media-breakpoint-down('sm') {
      padding-inline-end: 20px;
    }

    flex: 1 1 30%;
    box-sizing: border-box;

    :host(:not(.small)) & {
      max-width: 350px;
      min-width: 220px;
    }
  }
}

.filters {
  color: map.get($colors, darkgrey);
  background: white;
  font-size: 14px;

  :host(.small) & {
    position: fixed;
    width: 0;
    height: 0;
    z-index: 10;
    inset-block-start: 0;
    inset-inline-end: 0;
    transition: all 0s ease 0.5s;
    background: none;

    &.show {
      height: 100vh;
      width: 100vw;
      transition: all 0s ease 0s;

      &::after {
        opacity: 1;
      }
    }

    &::after {
      content: '';
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      inset: 0;
      z-index: -1;
      opacity: 0;
      transition: 0.1s ease opacity;
    }
  }

  &__close-filters {
    display: none !important;
    font-size: 1.4em;

    :host(.small) & {
      display: inline-block !important;
      margin-inline: auto 0;
      margin-block: 0;
    }
  }

  &__old-posts {
    margin-inline-start: 1rem;
  }

  &-wrap {
    :host(.small) & {
      position: absolute;
      inset-block-start: 0;
      inset-inline-end: 0;
      background: rgb(247, 246, 246);
      transform: translateX(100%);
      width: 300px;
      min-width: 200px;
      max-width: 80vw;
      transition: transform 0.3s ease;
      padding: 1em;
      color: black;
      overflow: auto;
      height: 100vh;
    }
  }

  &.show {
    .filters-wrap {
      :host(.small) & {
        transform: translateX(0%);
        box-shadow: -3px -3px 7px rgba(0, 0, 0, 0.1);
      }
    }
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    margin: 0;
    padding: 0;
  }

  nano-details {
    --padding: 0.8em;

    margin: 0.8em 0;

    strong[slot] {
      display: block;
      padding-inline-start: calc(20px - 0.8em);
    }

    nano-icon[slot='icon-end'] {
      padding-inline-start: calc(20px - 0.8em);
      padding-inline-end: calc(20px - 0.8em);
    }
  }

  li:last-child .filter-label {
    margin-block-end: 0;
  }

  .filter-label {
    display: flex;
    align-items: center;
    position: relative;
    margin: 0.5em 0;
    line-height: 1.4;
    z-index: 0;

    &::before {
      margin-inline: 0 1em;
      margin-block: 0;
      content: '';
      border: 1px solid map.get($colors, blue);
      background: map.get($colors, white);
      border-radius: 3px;
      height: 1em;
      width: 1em;
      min-width: 1em;
      min-height: 1em;
      display: inline-block;
    }

    &::after {
      @include svg-background-image(
        "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='#ffffff' d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'/></svg>"
      );

      content: '';
      height: 0.7em;
      width: 0.7em;
      position: absolute;
      inset-inline-start: 2px;
      inset-block-start: 50%;
      transform: translateY(-50%);
      z-index: 1;
      display: block;
      background-size: 100%;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }

  .filter-cb {
    @include visually-hide;

    &:checked + .filter-label {
      &::before {
        background: map.get($colors, blue--darker);
      }
    }

    &:focus + .filter-label {
      &::before {
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.7);
      }
    }
  }

  &-header {
    display: flex;
    align-items: center;
    border-block-end: 1px solid map.get($colors, lightblue);
    padding-block-end: 0.5rem;
    margin-block-end: 0.5rem;
  }

  &-reset {
    color: map.get($colors, blue);
    font-size: 12px;
    text-decoration: underline;
    margin-inline: auto 0;
    margin-block: 0;

    :host(.small) & {
      margin: 0;
    }
  }

  &-title {
    margin: 0;
    text-transform: uppercase;
    color: rgba(69, 85, 86, 0.85);
    font-weight: bold;
    font-size: 14px;

    :host(.small) & {
      display: none;
    }
  }
}

.result {
  text-decoration: none;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-block-end: 14px;
  border-block-end: 1px solid map.get($colors, lightblue);

  * {
    word-wrap: break-word;
    word-break: break-word;
  }

  &__title {
    margin: 1em 0 0.5em 0;
    width: 70%;
    display: flex;

    a {
      color: lighten(map.get($colors, blue), 4%);
      font-size: 14px;
      line-height: 1.43;
      text-decoration: none;
      font-weight: 600;
    }

    nano-icon {
      margin-inline: 0 0.5em;
      margin-block: 0;
      min-width: 20px;
      min-height: 20px;
      opacity: 0.8;
    }

    @include media-breakpoint-down('lg') {
      width: 100%;
    }
  }

  &__body {
    color: map.get($colors, darkgrey);
    font-size: 13px;
    width: 70%;
    text-decoration: none;

    @include media-breakpoint-down('lg') {
      width: 100%;
    }
  }

  &__pdf {
    display: inline-block;
    margin-inline-start: 0.5rem;
    color: map.get($colors, palegrey);
  }

  &__meta {
    display: flex;
    flex-flow: row wrap;
    color: map.get($colors, darkgrey);
    font-size: 11px;
    line-height: 13px;
    width: 100%;
    align-items: center;

    > * {
      margin-block-start: 0.5rem;

      &:not(:last-child) {
        padding-inline-end: 0;

        &::after {
          content: '';
          height: 1rem;
          width: 1px;
          background: #90c6e7;
          display: inline-block;
          margin-inline-start: 0.7rem;
          margin-inline-end: 0.7rem;

          @include media-breakpoint-down('sm') {
            display: none;
          }
        }
      }
    }

    @include media-breakpoint-down('sm') {
      flex-flow: column;
      align-items: flex-start;
    }
  }

  &__tags {
    display: flex;
    flex-flow: row wrap;

    @include media-breakpoint-down('sm') {
      padding-inline-start: 0;
    }

    &-tag {
      color: map.get($colors, darkgrey);
      display: inline-block;
      font-size: 0.4375rem;
      letter-spacing: 1.4px;
      background: #fff;
      border-radius: 2px;
      text-transform: uppercase;
      padding: 0 4px 1px 5px;
      font-weight: 600;
      margin: 3px 0.25rem 0.25rem 0;
      border: 1px solid #b5aea7;
      white-space: nowrap;
      line-height: 13px;
    }
  }

  &__type {
    font-weight: 600;
    text-transform: capitalize;
    white-space: nowrap;
    display: flex;
    align-items: center;
  }

  &__date {
    display: flex;
    align-items: center;
    color: map.get($colors, darkgrey);
  }

  &__source {
    color: map.get($colors, darkgrey);
    padding-inline-end: 0.75rem;
  }

  &__authors {
    font-size: 12px;
    color: map.get($colors, darkgrey);
    margin-block-end: 0.25rem;
    text-decoration: none;
    width: 70%;
  }

  &__buttons {
    width: 70%;
    margin-block-end: 0.5rem;

    &-button {
      background-color: map.get($colors, blue);
      color: #fff;
      padding: 5px 8px 1px;
      border-radius: 4px;
      display: inline-block;
      font-size: 11px;
      text-decoration: none;
      border: none;
    }
  }

  &__promo {
    width: 70%;
    margin-block-end: 0.5rem;
    text-decoration: none;
    color: map.get($colors, darkgrey);

    &-box {
      width: 300px;
      background-color: #e3eef1;
      padding: 12px 12px 8px 4px;
      display: flex;
      flex-flow: row nowrap;
      margin-block-start: 1rem;
    }

    &-bigdate {
      flex: 0 1 60px;
      text-align: center;
      font-weight: 600;
      color: map.get($colors, blue);
      text-transform: uppercase;
      line-height: 1.25;
      letter-spacing: 1.5px;

      @include media-breakpoint-down('lg') {
        width: 100%;
      }

      span {
        color: map.get($colors, darkgrey);
        display: block;
      }

      & ~ div {
        padding-inline-start: 1rem;
        border-inline-start: 1px solid #c5dbe1;
      }
    }

    &-date {
      font-size: 12px;
    }

    &-venue {
      font-size: 12px;
    }

    nano-icon {
      color: map.get($colors, blue);
      position: relative;
      inset-block-start: 1px;
      padding-inline-end: 2px;
    }
  }

  &__image {
    display: block;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 4px;
    position: relative;
    width: 100%;
    height: 150px;
    margin-block-end: 0.5rem;

    @include media-breakpoint-up('sm') {
      width: 142px;
      height: 80px;
    }

    nano-icon {
      position: absolute;
      inset-block-start: calc(50% - 0.75rem);
      inset-inline-start: calc(50% - 0.75rem);
      font-size: 1.5rem;
      color: #0084a9;

      --primary-color: #fff;
      --secondary-color: #0084a9;
      --primary-opacity: 1;

      @include media-breakpoint-down('sm') {
        font-size: 3rem;
        inset-block-start: calc(50% - 1.5rem);
        inset-inline-start: calc(50% - 1.5rem);
      }
    }
  }

  &__video {
    &-body {
      width: 70%;
      text-decoration: none;
      display: flex;
      flex-flow: row wrap;

      @include media-breakpoint-down('lg') {
        width: 100%;
      }

      @include media-breakpoint-down('sm') {
        flex-flow: column;
      }

      .result__body {
        padding-inline-start: 1rem;
        display: flex;
        flex-direction: column;
        margin-block-end: 0;
        flex: 1;

        @include media-breakpoint-down('sm') {
          padding-inline-start: 0;
        }

        p {
          display: inline;
          margin: 0;
        }

        u,
        li,
        a {
          text-decoration: none;
        }

        .result__meta {
          margin-block-start: 0.5rem;
        }

        .result__description {
          flex: 1 0 auto;
        }
      }
    }
  }
}

.search-empty {
  padding: 3rem 0;
  text-align: center;
  border-block-start: 1px solid #e5eef1;

  h2 {
    color: #455556;
    font-size: 1.125rem;
    margin-block-end: 0.5rem;
  }

  &-icon {
    font-size: 7rem;

    --icon-color: #e4e6e8;

    margin-block-end: 2rem;
  }
}

.search__highlight {
  background: #fbffbf;
  font-style: normal;
}
